<p-timeline [value]="managerLogPostSelected.managerLogComments" align="alternate" styleClass="customized-timeline">
    <ng-template pTemplate="marker" let-event>
        <span class="custom-marker p-shadow-2" [style.backgroundColor]="event.color">
            <fa-icon [icon]='["far","comments"]'></fa-icon>
        </span>
    </ng-template>
    <ng-template pTemplate="content" let-rec>
        <p-card [header]="moment(rec.created).format('l LT')" subheader="{{rec.authorUser?.firstName}} {{rec.authorUser?.lastName}}">
            <div class="ms-4" [innerHTML]="rec.body"></div>
        </p-card>
    </ng-template>
</p-timeline>